import * as api from './index';

export async function createCustomer() {
    return api.post('/stripe/customer');
}

export async function adminCreateCustomer(userId) {
    return api.post('/stripe/admin/customer', { user: userId });
}

export async function createSubscription(item) {
    const res = await api.post('/stripe/subscription', { item });
    if (res.ok) {
        if (res.body.latest_invoice?.payment_intent?.status === 'requires_action') {
            await confirmCardPayment(res.body.latest_invoice.payment_intent);
        }
    }

    return res;
}

export async function updateSubscription(item) {
    return api.post('/stripe/subscription', item, { method: 'PATCH' });
}

export async function cancelSubscription() {
    return api.post('/stripe/subscription/cancel');
}

export async function resumeSubscription() {
    return api.post('/stripe/subscription/resume');
}

export async function confirmSubscription() {
    return api.post('/stripe/subscription/confirm');
}

export async function getPaymentMethods() {
    return api.get('/stripe/paymentMethods');
}

export async function getPlanInfo(priceId) {
    return api.get(`/stripe/planInfo/${priceId}`);
}

export async function createPaymentMethod(paymentMethodId) {
    return api.post('/stripe/paymentMethods', { paymentMethod: paymentMethodId });
}

export async function removePaymentMethod(paymentMethodId) {
    return api.del(`/stripe/paymentMethods/${paymentMethodId}`);
}

export async function setDefaultPaymentMethod(paymentMethodId) {
    return api.post(`/stripe/paymentMethods/${paymentMethodId}/default`);
}

async function confirmCardPayment(paymentIntent) {
    const { client_secret, payment_method } = paymentIntent;
    const res = await window.app.$stripe.confirmCardPayment(client_secret, { payment_method });
    if (res.error) throw res.error;

    return res;
}
